// extracted by mini-css-extract-plugin
module.exports = {"Table":"Storefronts_Table__2YilE"};